/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { TTabletAccount } from "apis/workspace/tablet-code";
import { useEffect, useState } from "react";
import Modal from "react-modal";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onChange?: (updateTabletAccount: TTabletAccount) => void;
  tabletAccount?: TTabletAccount;
  isConflictError?: boolean;
};

const ChangeDeviceAccountModal = (props: Props) => {
  const { modalIsOpen, closeModal, onChange, tabletAccount, isConflictError } = props;
  const [tabletAccountId, setTabletAccountId] = useState<string>();
  const [tabletAccountPassword, setTabletAccountPassword] = useState<string>();

  const onHandleChange = () => {
    if (!enabledBtn()) return;

    if (tabletAccountId && tabletAccountPassword) {
      onChange?.({
        tabletAccountId: tabletAccountId ?? "",
        tabletAccountPassword: tabletAccountPassword ?? "",
      });
    }
  };

  const enabledBtn = () => {
    return (
      (tabletAccountId ?? "").length > 3 &&
      (tabletAccountPassword ?? "").length > 3 &&
      (tabletAccountId ?? "").length < 21
    );
  };

  useEffect(() => {
    setTabletAccountId(tabletAccount?.tabletAccountId ?? "");
    setTabletAccountPassword(tabletAccount?.tabletAccountPassword ?? "");
  }, [modalIsOpen]);

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <HeaderContainer>
          <UI.Typography type="heading02" fontStyle="bold">
            기기 로그인 계정
          </UI.Typography>
          <CancelIcon>
            <UI.IconButton.Normal
              type="primary"
              icon="x"
              size={20}
              color="var(--alias-color-label-normal)"
              onClick={closeModal}
            />
          </CancelIcon>
        </HeaderContainer>
        <FormContainer>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 4px;
            `}
          >
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              아이디
            </UI.Typography>
            <UI.Input
              value={tabletAccountId}
              showMaxLength={true}
              helpText={
                isConflictError ? "이미 사용 중인 아이디입니다." : "최소 4자 이상, 최대 20자 이하로 설정해 주세요."
              }
              maxLength={20}
              showHelpText
              onChange={setTabletAccountId}
              error={(tabletAccountId ?? "").length < 4 || isConflictError}
            ></UI.Input>
          </div>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 4px;
            `}
          >
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              비밀번호
            </UI.Typography>
            <UI.Input
              maxLength={16}
              value={tabletAccountPassword}
              helpText="최소 4자 이상으로 설정해 주세요."
              showHelpText
              onChange={setTabletAccountPassword}
              error={(tabletAccountPassword ?? "").length < 4}
            ></UI.Input>
          </div>
        </FormContainer>
        <div style={{ padding: "0 48px 40px 48px" }}>
          <UI.Button
            title="변경하기"
            size="large"
            style={{ width: "100%" }}
            onClick={onHandleChange}
            disabled={!enabledBtn()}
          />
        </div>
      </Container>
    </Modal>
  );
};

export default ChangeDeviceAccountModal;

const Container = styled.div`
  width: 516px;
  box-sizing: border-box;
  background-color: white;
  border-radius: 16px;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 68px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 2px solid var(--alias-color-line-normal);
  align-items: center;
`;

const CancelIcon = styled.div`
  cursor: pointer;
`;

const FormContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 32px;
  padding: 0 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
